/**
 * Prepare the image attributes parsing an object normally generated via backend
 * @param {object} src - object containing the image sources
 * @param {object} rest - additional attributes
 * @returns {object} attributes object for any <img> tags
 */
export default function imageAttributes({ src, ...rest }) {
    return {
        src: src['@1'],
        srcSet: `${ src['@1'] } 1x, ${ src['@2'] } 2x`,
        ...rest,
    };
}

/**
 * Prepare the image attributes parsing an object normally generated via backend
 * @param {object} src - object containing the image sources
 * @param {object} rest - additional attributes
 * @returns {object} attributes object for any <img> tags
 */
export function lazyImageAttributes({ src, ...rest }) {
    return {
        'data-src': src['@1'],
        'data-src-set': `${ src['@1'] } 1x, ${ src['@2'] } 2x`,
        ...rest,
    };
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/react/image-attributes.js